import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Table } from "primeng/table";
import { TableModule } from "primeng/table";
import { UserWalletService } from "src/app/services/userWallet.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import * as CryptoJS from "crypto-js";

import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { CustomValidators } from "ng2-validation";
import { WindowRefService } from "src/app/services/window-ref.service";
import { WalletpaymentService } from "src/app/services/walletPayments.service";
import {
  ConfirmationService,
  MenuItem,
  ConfirmEventType,
  MessageService,
} from "primeng/api";
import { UserService } from "src/app/services/user.service";

@Component({
  selector: "app-academy-wallet-redeem",
  templateUrl: "./academy-wallet-redeem.component.html",
  styleUrls: ["./academy-wallet-redeem.component.scss"],
  providers: [ConfirmationService, MessageService, WindowRefService],
})
export class AcademyWalletRedeemComponent implements OnInit {
  Adminpopup: boolean = false;
  availableClasses: string[] = ["body-dark", "bg-white", ""];
  currentClassIdx: number = 0;
  bodyClass: string;
  public walletlist: any = [];
  public userlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  public loggedInUser;
  paginationOption;
  downloadFlg: boolean;
  totalCoins;
  totalDeductedCoin;
  totalAvailableCoins;
  step: number = 0;
  activeIndex: number = 0;
  selectCashCoin: FormGroup;
  redemptionCash: any;
  redemptionCoin: any;
  totalCash;
  totalDeductedCash;
  addCashmodal: boolean = false;
  showThankyouModal: boolean = false;
  addCoinmodal: boolean = false;
  totalAvailableCash;
  public userId;
  selectCashCoinForm: FormGroup;
  selectcoinForm: FormGroup;
  selectBankAccountForm: FormGroup;
  tranferAmountForm: FormGroup;
  submitted = false;
  username;
  noData: boolean;
  coinsubmitted = false;
  userdetails: any;
  kycList: any;
  kyclist: any;
  coinCashData: any;
  cashCoinData: any;
  actualCash: any;
  actualCoin: any;
  redemptionAmount: any;
  transferCash: any;
  deductionCas: any;
  tranferAmountCash: any;
  redempCoin: any;
  tdsData: any;
  commissionData: any;
  totalTdsCommissionDeduction: any;
  totalAmount: any;
  bankId: any;
  bankDetaiols: any;
  displayParameter: any;
  inPutCoin: any;
  totalCoinTdsCommission: any;
  totalCoinCreatedAmoun: any;
  coinTds: any;
  coinCommission: any;
  listOfBank: any;
  userBankid: any;
  showMessage: boolean = false;
  totalCashToRedeem;
  private key = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
  private iv = CryptoJS.enc.Utf8.parse(environment.EncryptIV);
  tournamentId: any;
  constructor(
    private tokenStorage: TokenStorageService,
    private route: ActivatedRoute,
    private userWalletService: UserWalletService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private winRef: WindowRefService,
    private router: Router,
    private userService: UserService,
    private formBuilder: FormBuilder
  ) { }

  async ngOnInit(): Promise<void> {
    this.paginationOption = environment.pagination;
    this.loggedInUser = this.tokenStorage.getUser();

    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
    }

    this.selectCashCoinForm = this.formBuilder.group({
      redemptions: ["", Validators.required],
    });
    let tournamentData = this.tokenStorage.getTournamentData();
    if (tournamentData) {
      this.tournamentId = await this.decryptUsingAES256(tournamentData[0].tournamentId);
      this.totalCashToRedeem = await this.decryptUsingAES256(tournamentData[0].tournamentAmount);
      // this.tournamentId = tournamentData[0].tournamentId;
      // this.totalCashToRedeem = Number(tournamentData[0].tournamentAmount);
    }
    this.selectBankAccountForm = this.formBuilder.group({
      bankAccount: ["", Validators.required],
    });
    // this.tranferAmountForm = this.formBuilder.group({
    //   amount: ["", [Validators.required, CustomValidators.number]],
    // });
    this.tranferAmountForm = this.formBuilder.group({
      amount: ["", [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    });

    this.userdetails = this.getUserDetail();
    this.kycList = this.loadUserKyc();
  }

  get f() {
    return this.selectCashCoinForm.controls;
  }
  get f1() {
    return this.selectBankAccountForm.controls;
  }
  get f2() {
    return this.tranferAmountForm.controls;
  }

  getUserDetail() {
    var query = "?filterByDisable=false&filterByUserid=" + this.userId;
    this.userWalletService.getUserWalletList(query).subscribe(
      (data) => {
        this.loading = false;
        this.walletlist = data.data.items;
        this.totalCash = data.data.totalCash;
        this.totalDeductedCash = data.data.totalDeductedCash;
        this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
        this.totalCoins = data.data.totalCoins;
        this.totalDeductedCoin = data.data.totalDeductedCoin;
        this.totalAvailableCoins = this.totalCoins - this.totalDeductedCoin;
        this.totalRecords = data.data.totalCount;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  loadUserKyc() {
    var query = "?filterByStatus=true&filterDisable=false&filterByuserId=" + this.userId;
    this.userService.getUserKycDetailsList(query).subscribe((data) => {
      this.kyclist = data.items;
    });
  }
  next() {
    this.step = this.step + 1;
  }
  back() {
    if(this.step!=0){
    this.step = this.step - 1;}
    else if(this.step==0){
      this.router.navigate(["/payment-history"]);
    }
  }
  backHome() {
    this.router.navigate(["/payment-history"]);
  }
  onSubmit(): void {
    this.submitted = true;
    if (this.selectCashCoinForm.invalid) {
      return;
    }
    //this.cashCoinData = this.selectCashCoinForm.value.redemptions;
    this.step = 1;
  }

  onSubmit1(): void {
    this.submitted = true;
    if (this.selectBankAccountForm.invalid) {
      return;
    }
    this.bankId = this.selectBankAccountForm.value.bankAccount;
    this.step = 1;
  }
  onSubmit2(): void {

    this.redemptionAmount = this.totalCashToRedeem;
    this.tdsData = this.redemptionAmount / 100;
    this.commissionData = this.redemptionAmount * 0.10;
    this.totalTdsCommissionDeduction =  this.commissionData;
    this.totalAmount =
      this.redemptionAmount - this.totalTdsCommissionDeduction;
    this.inPutCoin = this.redemptionAmount / 10;
    this.coinTds = this.inPutCoin / 100;
    this.coinCommission = this.inPutCoin / 1000;
    this.totalCoinTdsCommission = this.coinTds + this.coinCommission;


    // if (this.redemptionAmount > this.totalAvailableCash) {
    //   return;
    // } else {
      this.submitted = true;
      this.step = 2;
    // }
  }
  onSubmit3() {
    let bankdetailsCash: any = {
      wallettype: "CASH",
      kycId: this.bankId,
      transferAmount: this.redemptionAmount,
      tds: this.tdsData,
      commission: this.commissionData,
      totalCreditedAmount: this.totalAmount,
      tournamentId: this.tournamentId,
      isClaim: true,
    };
    bankdetailsCash = JSON.stringify(bankdetailsCash, null, 4);
    this.userService.academysendManyToBank(bankdetailsCash).subscribe((res) => {
      this.showMessage = true;
      this.messageService.add({
        key: "toastmsg",
        severity: "success",
        summary: "Successful",
        detail: "Fund transfer request sent successfully",
        life: 6000,
      });
    });
    this.submitted = true;
    this.step = 3;
  }
  getDisplayValueCash() {
    this.redemptionAmount = this.tranferAmountForm.value.amount;
  }
  getDisplayValueCoin() {
    this.redemptionAmount = this.tranferAmountForm.value.amount;
    this.inPutCoin = this.redemptionAmount / 10;
  }

  showAdmindAlert() {
    this.Adminpopup = true;
  }
  async decryptUsingAES256(decString) {
    var decrypted = CryptoJS.AES.decrypt(decString, this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

}
